import React, { FunctionComponent, memo } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import Image from 'material-ui-image';
import OptionUnavailable from '../../../../../../../common/assets/images/optionUnavailable.png';
import accessoryItemStyles from './accessoryItemStyles';
import Checkbox from '@material-ui/core/Checkbox';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import useTheme from '@material-ui/core/styles/useTheme';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';
import { GetFeatureChildren_featureChildren } from '../../../../../../graphql/queries/__generated__/GetFeatureChildren';
import ConfigurablePrice from '../../../../../presentational/prices/configurablePrice/ConfigurablePrice';
import CustomTitle from '../../../../../presentational/customTitle/CustomTitle';

export interface IAccessoryItemProps {
  accessory: GetFeatureChildren_featureChildren;
  /**
   * Event used to handle logic on selecting the accessory
   */
  onClick: (name: string) => void;
  isSelected?: boolean;
  isSelectable?: boolean;
  inModal?: boolean;
}

const AccessoryItem: FunctionComponent<IAccessoryItemProps> = memo(
  ({ accessory, onClick, isSelectable = true, inModal = false, isSelected }) => {
    const styles = accessoryItemStyles();
    const theme = useTheme<ISpcTheme>();
    const {
      spc: {
        customise: { optionPriceLabel },
      },
    } = useTheme<ISpcTheme>();
    const isMobile = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.sm));
    const intl = useIntl();

    return (
      <Grid item={true} xs={inModal && !isMobile ? 4 : 6} className={styles.gridContainer}>
        <Box
          className={styles.container}
          data-test={`container:option:${accessory.code}`}
          onClick={() => onClick && onClick(accessory.code)}
        >
          <Image
            key={accessory.images[0]?.url}
            src={accessory.images[0]?.url || 'error'}
            alt={accessory.label}
            animationDuration={0}
            color="transparent"
            aspectRatio={1.75}
            errorIcon={
              <img
                src={OptionUnavailable}
                data-test={'image:vehicle:unavailable'}
                className={styles.errorImage}
                alt={'Error'}
              />
            }
          />
          <Box className={clsx([styles.body, { [styles.smallBody]: inModal }])}>
            <Typography variant="caption" className={styles.accessoryTitle}>
              <CustomTitle
                title={accessory.label}
                indicative={intl.formatMessage({
                  id: 'trans__configurator__indicative_numbers__customise_specific_option',
                })}
              />
            </Typography>

            <ConfigurablePrice
              prices={accessory.prices}
              display={{ optionPriceLabel }}
              classes={{ multi: { priceText: styles.priceText } }}
            />
          </Box>
          {isSelectable && (
            <Box
              className={styles.accessoryCheckContainer}
              data-test={`accessory:checkbox:${accessory.code}`}
              data-selected={`${isSelected}`}
            >
              <Checkbox checked={isSelected} />
            </Box>
          )}
        </Box>
      </Grid>
    );
  },
);

export default AccessoryItem;
